import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLastPathSegment } from 'shared/hooks'
import { Box } from 'shared/ui'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { BusinessAddressForm } from 'pages/settings/ui/BusinessAddressForm'
import { useInternationalStepsContext } from 'pages/settings/pages/compliance/pages/international/context/internationalStepsContext'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { type InternationalRoutes } from 'pages/settings/pages/compliance/pages/international'
import styles from './styles.module.scss'

export const BusinessAddress = observer(() => {
  const {
    stepsStore: { stepLoading },
    moveToSecondStep,
    initializeStepsForRoute,
    businessAddressStore,
    errorStore,
    nextDisabled,
  } = useInternationalStepsContext()
  const lastPathSegment = useLastPathSegment()
  const { fieldsError } = errorStore

  useEffect(() => {
    initializeStepsForRoute(lastPathSegment as InternationalRoutes)
  }, [initializeStepsForRoute, lastPathSegment])

  return (
    <div className={styles.wrap}>
      <Box marginBottom={5}>
        <PageDescription>Enter the physical address of the company</PageDescription>
      </Box>

      <BusinessAddressForm
        addressData={businessAddressStore.addressData}
        countries={businessAddressStore.countries}
        activeCountryId={businessAddressStore.activeCountryId}
        activeCountryInfo={businessAddressStore.activeCountryInfo}
        states={businessAddressStore.states}
        zipCode={businessAddressStore.zipCode}
        zipLocalErrorMessage={businessAddressStore.zipLocalErrorMessage}
        fieldsError={fieldsError ?? undefined}
        setActiveCountry={businessAddressStore.setActiveCountry}
        setStreet1={businessAddressStore.setStreet1}
        setStreet2={businessAddressStore.setStreet2}
        setCity={businessAddressStore.setCity}
        setState={businessAddressStore.setState}
        setZip={businessAddressStore.setZip}
        checkZipLength={businessAddressStore.checkZipLength}
        countrySelectClassName={styles.textField}
        textInputClassName={styles.textInput}
      />

      <NextButton
        text='Next'
        loading={stepLoading}
        disabled={stepLoading || nextDisabled}
        onClick={() => moveToSecondStep(lastPathSegment as InternationalRoutes)}
      />
    </div>
  )
})
